import { render, staticRenderFns } from "./unit-summary.vue?vue&type=template&id=673608ca&"
import script from "./unit-summary.vue?vue&type=script&lang=js&"
export * from "./unit-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports